<template>
  <div class="main">
    <c-panel title="Vínculo do Aluno" titleIcon="fas fa-user-friends">
      <form-aluno :paramId="id" @onSubmitTransporteAluno="afterSubmit"></form-aluno>
    </c-panel>
  </div>
</template>

<script>
import formAluno from "./form"

export default {
  components: { formAluno },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/aluno') }
  }
}
</script>

